import { css } from "@microsoft/fast-element";
import { HorizontalScrollStyles } from "@fluentui/web-components";
export const StripeStyles = css `
    ${HorizontalScrollStyles} :host {
        --scroll-fade-next: var(--background-color);
    }

    .heading-container {
        display: grid;
        grid-template-columns: 1fr auto;
        margin: 0 0 12px;
    }

    ::slotted([slot="action"]) {
        display: flex;
        align-items: flex-end;
    }

    ::slotted([slot="icon"]) {
        margin-inline-end: 8px;
    }

    .header,
    .header ::slotted(h1),
    .header ::slotted(h2),
    .header ::slotted(h3),
    .header ::slotted(h4),
    .header ::slotted(h5),
    .header ::slotted(h6) {
        font-size: var(--stripe-heading-font-size, var(--type-ramp-plus-2-font-size));
        line-height: var(
            --stripe-heading-line-height,
            var(--type-ramp-plus-2-line-height)
        );
        font-weight: 600;
        margin: 0;
    }

    ::slotted([slot="description"]) {
        font-size: var(--type-ramp-minus-1-font-size);
        line-height: var(--type-ramp-minus-1-line-height);
        margin: 8px 0 0;
    }
`;
